import React from 'react';
import { WarehousesComponent } from '../../../generated/graphql';
import { WarehouseScopeProvider } from './WarehouseScopeProvider';

const WarehousesScopeProviderQuery: React.FC = ({ children }) => {
    return (
        <WarehousesComponent nextFetchPolicy="cache-first">
            {({ data: { warehouses } }) => {
                return (
                    <WarehouseScopeProvider warehouses={warehouses}>{children}</WarehouseScopeProvider>
                );
            }}
        </WarehousesComponent>
    );
};

export default WarehousesScopeProviderQuery;
